<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Limit Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Limit Config</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="EWLimitConfig">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'EWLimitConfigList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">

                  <div class="form-group required">
                    <label class="control-label">Transaction activity type</label>
                    <multiselect id="trx_activity_type" name="trx_activity_type"
                                 :options="Object.keys(pre.trx_activity_type)"
                                 :custom-label="opt => pre.trx_activity_type[opt]"
                                 v-bind:class="{'has-error' : errors.has('trx_activity_type')}"
                                 v-validate="'required'"
                                 v-model="value.trx_activity_type_id" class="trx_activity_type"
                                 placeholder="Select Transaction activity type" :searchable="true"
                                 :close-on-select="true" :show-labels="false"></multiselect>
                    <div class="help text-danger" v-show="errors.has('trx_activity_type')">
                      {{ errors.first("trx_activity_type") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Frequency</label>
                    <multiselect id="frequency_id" name="frequency_id"
                                 :options="Object.keys(pre.frequency_id)"
                                 :custom-label="opt => pre.frequency_id[opt]"
                                 v-bind:class="{'has-error' : errors.has('frequency_id')}"
                                 v-validate="'required'"
                                 v-model="value.frequency_id" class="frequency_id"
                                 placeholder="Select Frequency" :searchable="true"
                                 :close-on-select="true" :show-labels="false"></multiselect>
                    <div class="help text-danger" v-show="errors.has('frequency_id')">
                      {{ errors.first("frequency_id") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Maximum Transaction Count</label>
                    <input type="text" id="max_trx_count" name="max_trx_count"
                           v-bind:class="{'has-error' : errors.has('max_trx_count')}"
                           v-validate="'required'"
                           v-model="value.max_trx_count" class="form-control max_trx_count"
                           placeholder="Maximum Transaction Count">
                    <div class="help text-danger" v-show="errors.has('max_trx_count')">
                      {{ errors.first("max_trx_count") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Maximum Transaction Amount</label>
                    <input type="text" id="max_trx_amount" name="max_trx_amount"
                           v-bind:class="{'has-error' : errors.has('max_trx_amount')}"
                           v-validate="'required'"
                           v-model="value.max_trx_amount" class="form-control max_trx_amount"
                           placeholder="Maximum Transaction Amount">
                    <div class="help text-danger" v-show="errors.has('max_trx_amount')">
                      {{ errors.first("max_trx_amount") }}
                    </div>
                  </div>

                  <div class="form-group ">
                    <label class="control-label">Status</label>
                    <select class="form-control" style="width: 100%;"
                            name="status" v-model="value.status" id="status">
                      <option value="active">active</option>
                      <option value="inactive">inactive</option>
                    </select>

                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWLimitConfigForm',
  metaInfo: {
    title: 'Limit Config | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      trx_activity_type: {},
      frequency_id: {},
    }
  }),
  methods: {


    trxActivityTypeOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/1")
          .then(response => {
            resolve(response.data)
            // return response.data
          })
          .catch((error) => {
            // console.log('error ' + error)
            reject(error)
          });
      });
    },

    frequencyOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/4")
          .then(response => {
            resolve(response.data)
            // return response.data
          })
          .catch((error) => {
            // console.log('error ' + error)
            reject(error)
          });
      });
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_limit_configs'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ew_limit_configs/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: {'Content-Type': 'application/json'},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWLimitConfigList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew-limit-configs-details/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize() {
      this.is_loading = true
      this.params = this.$route.params
      await this.trxActivityTypeOptions().then(trx_activity_type => {
        this.pre.trx_activity_type = trx_activity_type;
      })

      await this.frequencyOptions().then(frequency => {
        this.pre.frequency_id = frequency;
      })

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })


      }

      this.is_loading = false
    }
  },
  mounted() {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

